export const GRADE_10_PAGE_TITLE = 'أولى ثانوي Programming & AI';

export const GRADE_10_HERO_IMAGES = [
    '/img/ghonaim-transparent-tablet.png',
    '/img/ghonaim-transparent-standing-side.png',
];

export const grade10Hero = {
    badge: 'أولى ثانوي 2026–2027',
    title: 'ابدأ صح من أولى ثانوي… وافهم التكنولوجيا مش بس تستخدمها',
    subtitle:
        'في أولى ثانوي، Programming & AI مش مجرد مادة جديدة. دي بداية فهم الطالب للتكنولوجيا، المعلومات، البرمجة، والذكاء الاصطناعي بطريقة سهلة وعملية. مع البرمجة مع غنيم، الطالب يبدأ من الأساس ويمشي بخطة تساعده يحب المادة ويفهمها من بدري.',
    primaryCta: 'ابدأ كورس أولى ثانوي',
    secondaryCta: 'تواصل واتساب',
    chips: [
        'تأسيس من البداية',
        'شرح بسيط',
        'تدريب عملي',
        'أسئلة ومراجعات',
        'مناسب عربي ولغات',
    ],
    quick: [
        {
            title: 'ابدأ من الصفر',
            text: 'نفهم المصطلحات والفكرة قبل الدخول في الأسئلة.',
        },
        {
            title: 'شوف مثال سريع',
            text: 'كل جزء مربوط بحاجة الطالب بيستخدمها في يومه.',
        },
        {
            title: 'حل وراجع',
            text: 'تدريب قصير بعد الشرح عشان الطالب يعرف مستواه.',
        },
    ],
};

export const grade10Why = {
    title: 'ليه أولى ثانوي مهمة؟',
    subtitle:
        'أولى ثانوي هي البداية الحقيقية. الطالب اللي يفهم الأساس من بدري، هيكمل في تانية ثانوي وهو أقوى، وهيتعامل مع المادة بثقة أكبر.',
    cards: [
        {
            title: 'تأسيس قوي',
            text: 'نبدأ بالمفاهيم الأساسية من غير تعقيد، عشان الطالب يبني فهم صح من البداية.',
            illus: 'foundation',
        },
        {
            title: 'فهم قبل الحفظ',
            text: 'نشرح الفكرة بطريقة بسيطة تخلي الطالب يفهمها، مش يحفظها بس.',
            illus: 'understand',
        },
        {
            title: 'تدريب مستمر',
            text: 'بعد كل شرح، الطالب يحل ويتدرب عشان المعلومة تثبت.',
            illus: 'practice',
        },
        {
            title: 'استعداد لتانية ثانوي',
            text: 'الطالب اللي يتأسس صح في أولى ثانوي، يدخل تانية ثانوي وهو سابق بخطوة.',
            illus: 'ready',
        },
    ],
    roadmap: ['البداية', 'فهم', 'تدريب', 'تأسيس', 'جاهز لتانية ثانوي'],
    closing: 'أولى ثانوي مش سنة عادية… دي السنة اللي بتبني الأساس.',
};

export const grade10Topics = {
    title: 'هنتعلم إيه في أولى ثانوي؟',
    subtitle:
        'في أولى ثانوي، الطالب يبدأ يتعرف على أساسيات التكنولوجيا والمعلومات والبرمجة بطريقة مناسبة لسنّه ومستواه.',
    bridge: 'من التكنولوجيا اللي حواليك… إلى أول خطوة في البرمجة',
    items: [
        {
            title: 'المعلومات والوسائط',
            text: 'نفهم الفرق بين أنواع المعلومات وإزاي التكنولوجيا بتعرضها.',
            tag: 'أساسيات',
            illus: 'media',
        },
        {
            title: 'أخلاقيات المعلومات',
            text: 'نتعلم الاستخدام الصح والمسؤول للتكنولوجيا.',
            tag: 'وعي رقمي',
            illus: 'ethics',
        },
        {
            title: 'البيانات الشخصية والخصوصية',
            text: 'نعرف يعني إيه خصوصية وإزاي نحافظ على بياناتنا.',
            tag: 'أمان',
            illus: 'privacy',
        },
        {
            title: 'أمن المعلومات',
            text: 'نفهم أساسيات الأمان والحماية الرقمية.',
            tag: 'حماية',
            illus: 'security',
        },
        {
            title: 'الاتصالات والشبكات',
            text: 'نبدأ نفهم الإنترنت والشبكات بشكل بسيط.',
            tag: 'شبكات',
            illus: 'network',
        },
        {
            title: 'تصميم المعلومات',
            text: 'نتعلم إزاي نرتب المعلومات ونقدمها بشكل أوضح.',
            tag: 'تنظيم',
            illus: 'design',
        },
        {
            title: 'الكمبيوترات والدوائر المنطقية',
            text: 'نفهم أساسيات عمل الكمبيوتر بطريقة مبسطة.',
            tag: 'منطق',
            illus: 'hardware',
        },
        {
            title: 'قواعد البيانات',
            text: 'نتعرف على فكرة تخزين البيانات وتنظيمها.',
            tag: 'بيانات',
            illus: 'database',
        },
        {
            title: 'تحليل البيانات',
            text: 'نبدأ نفهم إزاي نقرأ البيانات ونستفيد منها.',
            tag: 'تحليل',
            illus: 'analytics',
        },
        {
            title: 'المحاكاة',
            text: 'نشوف إزاي التكنولوجيا بتساعدنا نجرب مواقف بشكل افتراضي.',
            tag: 'تجربة',
            illus: 'simulation',
        },
        {
            title: 'أساسيات البرمجة Python',
            text: 'نأخذ أول خطوة في التفكير البرمجي وكتابة الكود.',
            tag: 'برمجة',
            illus: 'python',
        },
    ],
};

export const grade10System = {
    title: 'نظامنا في أولى ثانوي',
    subtitle: 'مش مجرد فيديوهات. إحنا بنساعد الطالب يفهم، يتدرب، ويراجع بشكل بسيط ومنظم.',
    cards: [
        { title: 'شرح بسيط', text: 'نشرح الدرس خطوة بخطوة وبأسلوب واضح.', illus: 'explain' },
        { title: 'أمثلة من الحياة', text: 'نربط التكنولوجيا بالموبايل، التطبيقات، الإنترنت، والألعاب.', illus: 'life' },
        { title: 'أسئلة بعد كل درس', text: 'الطالب يتدرب بعد الشرح عشان يثبت الفكرة.', illus: 'quiz' },
        { title: 'مراجعات قصيرة', text: 'مراجعات تساعد الطالب ما يراكمش المنهج.', illus: 'review' },
        { title: 'تطبيق عملي', text: 'في الأجزاء العملية، الطالب يجرب بنفسه ويبدأ يكتب الكود.', illus: 'code' },
        { title: 'متابعة ومجتمع', text: 'مكان للمتابعة، التنبيهات، والسؤال عند الحاجة.', illus: 'community' },
    ],
    flow: ['شرح', 'تطبيق', 'حل', 'مراجعة'],
    lessonSteps: [
        {
            title: 'الفكرة',
            text: 'نبدأ بسؤال بسيط: الدرس بيتكلم عن إيه؟',
        },
        {
            title: 'المثال',
            text: 'نربط الدرس بحاجة من الموبايل أو الإنترنت أو الألعاب.',
        },
        {
            title: 'التدريب',
            text: 'الطالب يحل بنفسه ويعرف نقطة الضعف بسرعة.',
        },
        {
            title: 'المراجعة',
            text: 'نرجع للمهم قبل ما المنهج يتراكم.',
        },
    ],
    closing: 'الهدف إن الطالب يحب المادة، يفهمها، ويبدأ يبني أساس قوي من أولى ثانوي.',
};

export const grade10Study = {
    title: 'الطالب يعمل إيه عشان يستفيد؟',
    subtitle:
        'في أولى ثانوي، الاستفادة الحقيقية تيجي من إن الطالب يمشي بخطوات بسيطة وثابتة طول السنة.',
    steps: [
        'احضر الشرح بتركيز',
        'اكتب الملاحظات المهمة',
        'حل بعد كل درس',
        'ما تسيبش سؤال مش فاهمه',
        'راجع كل أسبوع',
        'جرّب الكود بنفسك',
        'تابع YouTube وTelegram',
        'اسأل لما تقف',
    ],
    highlight: 'الطالب اللي يبدأ صح من أولى ثانوي، بيدخل تانية ثانوي وهو أقوى بفرق واضح.',
};

export const grade10Parents = {
    title: 'رسالة لولي الأمر',
    text:
        'احنا عارفين إنكم قلقانين إن المادة تكون جديدة أو صعبة على ابنكم. علشان كده برنامج أولى ثانوي في البرمجة مع غنيم معمول عشان يأسس الطالب بهدوء، ويفهمه الفكرة قبل ما يحفظ، ويخليه يتدرب خطوة بخطوة من غير ضغط أو تعقيد.',
    points: [
        'شرح مبسط وواضح',
        'تأسيس مهم لتانية ثانوي',
        'تدريب ومراجعات',
        'ربط المادة بالحياة والتكنولوجيا',
        'هدفنا إن الطالب يفهم ويحب المادة',
    ],
    highlight: 'إحنا مش بنعلّم الطالب ينجح في المادة وبس… إحنا بنساعده يبدأ صح.',
};

export const grade10Faq = {
    title: 'أسئلة شائعة عن أولى ثانوي',
    items: [
        {
            q: 'هل كورس أولى ثانوي مناسب لو الطالب ضعيف في الكمبيوتر؟',
            a: 'آه مناسب. إحنا بنبدأ من الأساس وبنشرح بطريقة سهلة، ومش بنفترض إن الطالب شاطر في الكمبيوتر من البداية.',
        },
        {
            q: 'هل المادة محتاجة حفظ ولا فهم؟',
            a: 'فيها مصطلحات لازم تتراجع، لكن الأساس هو الفهم. لو الطالب فهم الفكرة، هيعرف يتعامل مع السؤال حتى لو اتكتب بشكل مختلف.',
        },
        {
            q: 'هل الكورس بيغطي النظري والعملي؟',
            a: 'آه، بنغطي الأفكار النظرية والعملية بطريقة مناسبة للمرحلة، مع تدريبات وأسئلة تساعد الطالب يفهم ويطبق.',
        },
        {
            q: 'هل الطالب لازم يكون عارف برمجة قبل الكورس؟',
            a: 'لا. أولى ثانوي هي بداية التأسيس، والطالب يقدر يبدأ معانا من الصفر.',
        },
        {
            q: 'هل في تدريبات بعد الشرح؟',
            a: 'آه، التدريب جزء أساسي من النظام. الطالب لازم يحل بعد الشرح عشان يعرف مستواه ويثبت الفهم.',
        },
        {
            q: 'هل الكورس مناسب لطلاب المدارس العربي؟',
            a: 'آه، مناسب جدًا. الشرح بسيط وواضح، وبنساعد الطالب يفهم المصطلحات والفكرة بطريقة تناسبه.',
        },
        {
            q: 'هل الكورس مناسب لطلاب المدارس اللغات و English Schools؟',
            a: 'آه، مناسب جدًا لطلاب English Schools والمدارس اللغات. بنهتم بالمصطلحات المهمة بالإنجليزي، وطريقة الشرح تساعد الطالب اللي بيدرس بالإنجليزي أو العربي.',
        },
        {
            q: 'هل الطالب العربي يقدر يستفيد حتى لو في مصطلحات إنجليزي؟',
            a: 'آه طبعًا. إحنا بنوضح المصطلحات المهمة بشكل سهل، فالطالب العربي يقدر يفهم ويستفيد بدون مشكلة.',
        },
        {
            q: 'هل أولى ثانوي مهمة لتانية ثانوي؟',
            a: 'جداً. لأن أولى ثانوي بتبني الأساس اللي الطالب هيحتاجه لما يدخل تانية ثانوي ويتعامل مع Programming & AI بشكل أعمق.',
        },
        {
            q: 'هل في مراجعات قبل الامتحان؟',
            a: 'آه، هيكون فيه مراجعات تساعد الطالب يلم الأفكار المهمة ويتدرب على شكل الأسئلة.',
        },
        {
            q: 'هل الطالب هيكتب كود بإيده؟',
            a: 'في الأجزاء العملية، آه. لأن البرمجة لا تُفهم بالمشاهدة فقط، لازم الطالب يجرب بنفسه.',
        },
        {
            q: 'هل في متابعة أو Community؟',
            a: 'آه، هيكون فيه قنوات متابعة وتنبيهات ومكان للطلاب يسألوا ويتابعوا المهم.',
        },
        {
            q: 'هل الصفحة دي للطالب ولا لولي الأمر؟',
            a: 'لاتنين. الطالب يعرف هيتعلم إيه ويمشي إزاي، وولي الأمر يطمن إن ابنه داخل نظام واضح ومناسب للمرحلة.',
        },
        {
            q: 'هل أولى ثانوي مجرد مادة ولا ليها علاقة بالمستقبل؟',
            a: 'هي مادة مهمة، لكن كمان بتدي الطالب بداية قوية لفهم التكنولوجيا والبرمجة، وده يفيده بعد كده في تانية ثانوي وفي طريقه للمستقبل.',
        },
    ],
};

export const grade10FinalCta = {
    title: 'جاهز تبدأ أولى ثانوي صح؟',
    subtitle:
        'ابدأ مع البرمجة مع غنيم وخلي عندك أساس قوي يساعدك تفهم Programming & AI من البداية بطريقة سهلة ومنظمة.',
    primaryCta: 'ابدأ الآن',
    secondaryCta: 'تواصل واتساب',
    hashtag: '#البرمجة_مع_غنيم',
};
